export const collabTemplateData = [
  {
    id: 1,
    name: "NDA Template",
    file:'Non_Disclosure',
    description: "Non-disclosure agreement for new partnerships",
    checklist: ["Upload NDA file", "Assign contributors", "Set deadline"],
    sampleDocuments: ["nda_sample.pdf"],
    defaultCredits: 5,
    defaultDuration: 10,
    type: "Global",
    createdBy: "admin@gmail.com",
    createdOn: "2025-12-08",
  },
  {
    id: 2,
    name: "Collaboration Agreement",
    file:"collaborative-agreement.docx",
    description: "Internal collaboration for project X",
    checklist: ["Assign team members", "Set milestones", "Upload contract"],
    sampleDocuments: ["collaborative-agreement"],
    defaultCredits: 5,
    defaultDuration: 10,
    type: "User",
    createdBy: "user@company.com",
    createdOn: "2025-12-08",
  },
  {
    id: 3,
    name: "Memorandum of Understanding – TechPartners",
    file:'MOU_Template.docx',
    description: "Outline understanding and responsibilities between TechPartners",
    checklist: ["Define scope", "Assign signatories", "Upload MoU document"],
    sampleDocuments: ["MOU_Template.docx"],
    defaultCredits: 5,
    defaultDuration: 10,
    type: "Global",
    createdBy: "admin@company.com",
    createdOn: "2025-12-08",
  },
  {
    id: 4,
    name: "Confidentiality Agreement – DataSecure Inc",
    file:'Confidentiality_template.docx',
    description: "Protect sensitive information during collaborations",
    checklist: ["Upload agreement", "Define confidentiality terms", "Assign contributors"],
    sampleDocuments: ["Confidentiality_template"],
    defaultCredits: 5,
    defaultDuration: 10,
    type: "Global",
    createdBy: "admin@company.com",
    createdOn: "2025-12-08",
  },
  {
    id: 5,
    name: "Project Kickoff Agreement – Horizon Project",
    file:'Project_Kickoff_Template.docx',
    description: "Formalize project start, roles, and milestones",
    checklist: ["Upload kickoff document", "Define milestones", "Assign project lead"],
    sampleDocuments: ["Project_Kickoff_Template"],
    defaultCredits: 5,
    defaultDuration: 10,
    type: "User",
    createdBy: "user@gamil.com",
    createdOn: "2025-12-08",
  },
  {
    id: 6,
    name: "Consultancy Contract – Bright Minds",
    file:'Consulting_Contract.docx',
    description: "Agreement for consultancy services provided by Bright Minds",
    checklist: ["Upload contract", "Define services scope", "Set deadlines"],
    sampleDocuments: ["Consulting_Contract.docx"],
    defaultCredits: 5,
    defaultDuration: 10,
    type: "Global",
    createdBy: "admin@company.com",
    createdOn: "2025-12-08",
  },
  {
    id: 7,
    name: "Joint Venture Agreement – SolarEnergy Co",
    file:'Joint-Venture-Agreement.docx',
    description: "Agreement for a joint venture with SolarEnergy Co",
    checklist: ["Define partnership terms", "Upload agreement", "Assign contributors"],
    sampleDocuments: ["Joint-Venture-Agreement.docx"],
    defaultCredits: 5,
    defaultDuration: 10,
    type: "Global",
    createdBy: "admin@company.com",
    createdOn: "2025-12-08",
  },
  {
    id: 8,
    name: "Supplier Agreement – Global Supplies Ltd",
    file:'NG30-Supply_ Agreement.docx',
    description: "Formal agreement with suppliers for materials/services",
    checklist: ["Upload agreement", "Define supply terms", "Set delivery schedules"],
    sampleDocuments: ["NG30-Supply_ Agreement"],
    defaultCredits: 5,
    defaultDuration: 10,
    type: "Global",
    createdBy: "admin@gmail.com",
    createdOn: "2025-12-08",
  },
  {
    id: 9,
    name: "Research Collaboration – BioLabs",
    file:'Collaborative-Research-Agreement-Template.docx',
    description: "Agreement to collaborate on research initiatives",
    checklist: ["Upload research plan", "Assign researchers", "Define milestones"],
    sampleDocuments: ["Collaborative-Research-Agreement-Template"],
    defaultCredits: 5,
    defaultDuration: 10,
    type: "User",
    createdBy: "user@company.com",
    createdOn: "2025-12-08",
  },
  {
    id: 10,
    name: "Event Partnership Agreement – CityFest 2026",
    file:'partnership-agreement-template.docx',
    description: "Formalize partnership for the CityFest 2026 event",
    checklist: ["Upload event agreement", "Define roles", "Set deadlines"],
    sampleDocuments: ["partnership-agreement-template"],
    defaultCredits: 5,
    defaultDuration: 10,
    type: "User",
    createdBy: "user@gmail.com",
    createdOn: "2025-12-08",
  },
  {
    id: 11,
    name: "Software Development Contract – CodeMasters",
    file:'Software-Development-Plan-Template.docx',
    description: "Agreement for software development with CodeMasters",
    checklist: ["Upload contract", "Define deliverables", "Set milestones"],
    sampleDocuments: ["Software-Development-Plan-Template"],
    defaultCredits: 5,
    defaultDuration: 10,
    type: "User",
    createdBy: "user@company.com",
    createdOn: "2025-12-08",
  },
  {
    id: 12,
    name: "IP Licensing Agreement – CreativeWorks",
    file:'IP-Licensing-Agreement.docx',
    description: "License intellectual property rights to CreativeWorks",
    checklist: ["Upload IP agreement", "Define licensing terms", "Assign contributors"],
    sampleDocuments: ["IP-Licensing-Agreement"],
    defaultCredits: 5,
    defaultDuration: 10,
    type: "Global",
    createdBy: "admin@gamil.com",
    createdOn: "2025-12-08",
  },
   {
    id: 12,
    name: "Trademark Licensing Agreement – BrandGuard",
    file:'Trademark-license-agreement.docx',
    description: "License intellectual property rights to BrandGuard",
    checklist: ["Upload trademark agreement", "Define licensing terms", "Assign contributors"],
    sampleDocuments: ["Trademark-license-agreement"],
    defaultCredits: 5,
    defaultDuration: 10,
    type: "Global",
    createdBy: "admin@gamil.com",
    createdOn: "2025-12-08",
  },

];
